var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"examsList"},[_c('span',[_vm._v("token: "+_vm._s(_vm.userInfo.token))])])
}
var staticRenderFns = []

export { render, staticRenderFns }